import { gql } from '@apollo/client';

export const subscriptions = {
  GET_METERS: gql`
    subscription ($where: meters_bool_exp) {
      meters(where: $where, order_by: { id: desc }) {
        id
        serial_number
        model
        updated_at
        brand
        created_at
        is_taken

        meter_readings {
          battery
          updated_at
          meter_id
          value
          is_billed
          id
          date_time
          created_at
        }
      }
    }
  `,
};
